<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <div class="user_info_box">
      <div class="section fill">
        <div class="inner">
          <!-- 개인정보수정 -->
          <div class="user_info">
            <div class="user_photo">
              <img class="photo" :src="user.img" :alt="user.name" />
            </div>
            <p class="user_name">
              <em>{{ user.name }}</em
              >{{ $t('library.sidebar.nim') }}
            </p>
            <p class="user_id">{{ user.email }}</p>
          </div>
          <div class="btn_wrap">
            <router-link :to="{ name: 'edit_account' }" class="box_btn dull"
              ><span class="an_t">{{
                $t('views.member.seller.requestpayout.4383')
              }}</span></router-link
            >
            <a href="javascript:void(0)" class="box_btn line"
              ><span class="an_t">{{
                $t('views.member.seller.requestpayout.4940')
              }}</span></a
            >
          </div>

          <!-- 마이페이지 메뉴 -->
          <div class="mypage_menu">
            <ul>
              <li>
                <router-link :to="{ name: 'orders' }" class="">{{
                  $t('views.member.seller.requestpayout.2809')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'refunds' }" class="">{{
                  $t('views.member.seller.requestpayout.3979')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'reviews' }" class="">{{
                  $t('views.member.seller.requestpayout.7961')
                }}</router-link>
              </li>
              <li class="quarter_web">
                <router-link :to="{ name: 'selfbook_sales' }" class="active">{{
                  $t('views.member.seller.requestpayout.1094')
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="apply_detail">
      <div class="section fill">
        <div class="inner">
          <div class="box_title">
            <h2>{{ $t('views.member.seller.requestpayout.2932') }}</h2>
            <p class="guide_txt">
              {{ $t('views.member.seller.requestpayout.6988') }}
            </p>
          </div>

          <div class="account_wrap">
            <div class="btn_wrap">
              <router-link
                :to="{ name: 'edit_bank_account' }"
                class="box_btn line"
              >
                <span class="an_t">{{
                  $t('views.member.seller.requestpayout.edit')
                }}</span>
              </router-link>
            </div>

            <div class="flex_wrap">
              <div>
                <p class="c_icon ico_apply_user"></p>
                <p class="sub_txt">
                  {{ $t('views.member.seller.requestpayout.1377') }}
                </p>
                <p class="account_name">{{ user.account.holder }}</p>
              </div>
              <div>
                <p class="c_icon ico_apply_bank"></p>
                <p class="sub_txt">
                  {{ $t('views.member.seller.requestpayout.bank') }}
                </p>
                <p class="account_bank">{{ user.account.bank }}</p>
              </div>
              <div>
                <p class="c_icon ico_apply_account"></p>
                <p class="sub_txt">
                  {{ $t('views.member.seller.requestpayout.7310') }}
                </p>
                <p class="account_number">{{ user.account.number }}</p>
              </div>
            </div>
          </div>

          <div class="box_inner">
            <dl>
              <dt>{{ $t('views.member.seller.requestpayout.1827') }}</dt>
              <dd>
                <strong>
                  <vue-intl-numberformat
                    locale="ko-KR"
                    class="price"
                    format-style="currency"
                    :currency="getCurrency.currency"
                    :number="user.currentFunds"
                  />
                </strong>
              </dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="section full">
        <div class="inner">
          <div class="form_wrap">
            <div class="sub_tit">
              {{ $t('views.member.seller.requestpayout.8137') }}
            </div>
            <div class="input_wrap">
              <input
                v-model="amountRequested"
                type="number"
                class="input_t"
                name="amountRequested"
              />
            </div>
          </div>
          <div class="btn_wrap">
            <a
              class="box_btn line"
              @click="injectAmount($data.user.currentFunds)"
            >
              <span class="ico_apply_plus"></span>
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.45')
              }}</span>
            </a>
            <a class="box_btn line" @click="injectAmount(1000000)">
              <span class="ico_apply_plus"></span>
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.8541')
              }}</span>
            </a>
            <a class="box_btn line" @click="injectAmount(500000)">
              <span class="ico_apply_plus"></span>
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.9875')
              }}</span>
            </a>
            <a class="box_btn line" @click="injectAmount(100000)">
              <span class="ico_apply_plus"></span>
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.2579')
              }}</span>
            </a>
          </div>
          <div class="box_inner">
            <div class="dl">
              <p class="dt">
                {{ $t('views.member.seller.requestpayout.3381') }}
              </p>
              <p class="dd">
                <strong>
                  <vue-intl-numberformat
                    locale="ko-KR"
                    class="price"
                    format-style="currency"
                    :currency="getCurrency.currency"
                    :number="user.currentFunds"
                  />
                </strong>
              </p>
            </div>
            <div class="dl">
              <p class="dt">
                {{ $t('views.member.seller.requestpayout.1286') }}
              </p>
              <p class="dd">
                <strong>
                  <vue-intl-numberformat
                    locale="ko-KR"
                    class="price"
                    format-style="currency"
                    :currency="getCurrency.currency"
                    :number="afterPayout"
                  />
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="section fill">
        <div class="inner">
          <p class="guide_txt tar">
            {{ $t('views.member.seller.requestpayout.648') }}
          </p>
          <div class="top_title">
            <p>{{ $t('views.member.seller.requestpayout.7159') }}</p>
          </div>
          <div class="total_price_wrap">
            <div class="table_wrap flex">
              <div>
                <span class="dt">{{
                  $t('views.member.seller.requestpayout.656')
                }}</span>
                <span class="dd">
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="amountRequested"
                    />
                  </strong>
                </span>
              </div>
              <div class="c_icon ico_apply_minus"></div>
              <div>
                <span class="dt">{{
                  $t('views.member.seller.requestpayout.8479')
                }}</span>
                <span class="dd">
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="withholdingCalc"
                    />
                  </strong>
                </span>
              </div>
              <div class="c_icon ico_cart_equals"></div>
              <div>
                <span class="dt">{{
                  $t('views.member.seller.requestpayout.4386')
                }}</span>
                <span class="dd total_price">
                  <strong>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="price"
                      format-style="currency"
                      :currency="getCurrency.currency"
                      :number="total"
                    />
                  </strong>
                </span>
              </div>
            </div>
          </div>

          <div class="btn_wrap" data-detail="btn_bottom">
            <router-link :to="{ name: 'orders' }" class="box_btn dull">
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.cancel')
              }}</span>
            </router-link>
            <a class="box_btn" @click="requestPayout">
              <span class="an_t">{{
                $t('views.member.seller.requestpayout.4520')
              }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <transition name="modal-fade">
      <Modal
        v-if="showFundsLackModal"
        v-on-clickaway="toggleFundsLackModal"
        @close="toggleFundsLackModal"
      >
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleFundsLackModal"
                ><span>{{
                  $t('views.member.seller.requestpayout.close')
                }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p class="tac">
                {{ $t('views.member.seller.requestpayout.5686') }}
              </p>
              <div class="btn_wrap">
                <button class="box_btn" @click="toggleFundsLackModal">
                  <span class="an_t">{{
                    $t('views.member.seller.requestpayout.ok')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestPayout',

  data() {
    return {
      showFundsLackModal: false,
      // user: {
      //   name: 'User Name',
      //   img: require('@/assets/images/guide/profile.png'),
      //   email: 'user@test.com',
      //   currentFunds: 100000,
      //   account: {
      //     holder: 'Account Holder',
      //     bank: '테스트 은행',
      //     number: '123123-23123-2323'
      //   }
      // },
      amountRequested: 0,
      withholding: 0.033
    }
  },

  computed: {
    ...mapGetters(['getCurrency']),

    afterPayout() {
      return this.user.currentFunds - this.amountRequested
    },
    withholdingCalc() {
      return this.amountRequested * this.withholding
    },
    total() {
      return this.amountRequested - this.withholdingCalc
    }
  },

  methods: {
    injectAmount(value) {
      this.amountRequested = value
    },
    requestPayout() {
      if (this.amountRequested > this.user.currentFunds) {
        this.toggleFundsLackModal()
      } else {
        // TODO: @Stan Request payout action
      }
    },
    toggleFundsLackModal() {
      this.showFundsLackModal = !this.showFundsLackModal
    }
  }
}
</script>

<style lang="scss" scoped></style>
